// extracted by mini-css-extract-plugin
export default {"page":"AdminPortal_page__Gnz5p","grid":"AdminPortal_grid__7vsRV","flex":"AdminPortal_flex__wO5rX","center":"AdminPortal_center__z4pj1"};